import { isAddressComplete, isAddressForced } from '../address.utils';
import { ADDRESS_CLASSIFICATION, MILITARY_STATES } from '../constants';

const hasBeenVerified = ({ status, classification }, verifyForced) =>
  verifyForced
    ? status && status !== 'forced' && classification
    : status && classification;

const shouldVerify = (address, verifyForced) =>
  isAddressComplete(address) &&
  !hasBeenVerified(address, verifyForced) &&
  (verifyForced || !isAddressForced(address));

export class AddressVerifierService {
  constructor($q, updSmartyStreetsService) {
    'ngInject';
    this._$q = $q;
    this._service = updSmartyStreetsService;
  }

  verify(address, verifyForced) {
    return (shouldVerify(address, verifyForced)
      ? this._service.request(address)
      : this._$q.resolve(address)
    ).then(result => ({
      ...result,
      // While smartystreets provides its own classification of military addresses it doesn't classify invalid addresses
      // as military if they have a military state. We want to classify such addresses as military since they can never
      // be forwarded to.
      classification: MILITARY_STATES.includes(address.state)
        ? ADDRESS_CLASSIFICATION.MILITARY
        : result.classification || ADDRESS_CLASSIFICATION.UNKNOWN,
    }));
  }
}
